export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};